import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen dark:bg-dark-primary"
}
const _hoisted_3 = { class: "flex items-center py-2 justify-between border-b-2 border-blue-secondary dark:border-blue-primary px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-secondary dark:text-pink-primary" }, "Happy Mookata House", -1)
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2 text-blue-secondary dark:text-pink-primary text-xs" }, "Dark Theme", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-24 dark:bg-dark-primary" }, null, -1)

import { useRoute } from 'vue-router';
import InputSwitch from 'primevue/inputswitch';
import {useDark} from '@vueuse/core'
import SideBarComponentVue from './components/SideBarComponent.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentRoute = computed(() => { 
  return useRoute().path
})

const isDark = useDark()
const arraySet = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
let item = localStorage.getItem('temporaryOrders')
let item2 = localStorage.getItem('savedOrders')
if(item==null){
  localStorage.setItem('temporaryOrders',JSON.stringify(arraySet))
}
if(item2==null){
  localStorage.setItem('savedOrders',JSON.stringify([]))
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(currentRoute).includes('print'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SideBarComponentVue),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(InputSwitch), {
              modelValue: _unref(isDark),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDark) ? (isDark).value = $event : null))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_router_view),
        _hoisted_7
      ]))
}
}

})